import React from 'react';

import {SanityFactoid} from 'types/generated';

export const Factoid: React.FC<SanityFactoid> = props => {
  return (
    <section className="float-left w-full md:w-[38%] relative mb-6 md:pr-6" data-module="factoid">
      <div className="flex items-center justify-center flex-wrap md:flex-nowrap md:space-x-9 relative z-10">
        <div className="w-full flex flex-col justify-center items-center md:px-0 max-w-[250px]">
          <div className="text-dark-gold">
            <span className="font-sans text-[100px] leading-none">{props.statNumber}</span>
            <span className="type-beta text-dark-gold">{props.statSymbol}</span>
          </div>
          <div className="flex text-center flex-col mt-2">
            <p className="type-lota mb-2">{props.statDescription}</p>
            <span className="type-xs-p">{props.statMicroCopy}</span>
          </div>
        </div>
      </div>
    </section>
  );
};
